export const MessagingAnalyticsQueryKeys = {
  base: ['messagingAnalytics'] as const,

  charts: (query?: string) => [...MessagingAnalyticsQueryKeys.base, 'charts', query],
  filterOptions: () => [...MessagingAnalyticsQueryKeys.base, 'filterOptions'],
  report: (query?: string) => [...MessagingAnalyticsQueryKeys.base, 'report', query],
};
